import GeneralSlider from './Slider';
import MenuSlider from './Slider.menu';
import DestacatSlider from './Slider.destacat';

export default function Component(props) {
    const { tipus } = props;

    if (tipus === 'menu') {
        return <MenuSlider {...props} />;
    } else if (tipus === 'destacat') {
        return <DestacatSlider {...props} />;
    } else {
        return <GeneralSlider {...props} />;
    }
}
